import { Fab, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import AccessControl from "@/components/AccessControl/AccessControl";
import { ELEMENT_TYPE, TAB_STATUSES } from "@/constants";
import { EditWhite, PlusWhite } from "@/icons";
import { setElementsDialog } from "@/store/actions";
import {
  contentElementsSelector,
  elementsDialogSelector,
  elementsSelector,
  simpleValuesSelector,
} from "@/store/selectors";

import ElementsDialog from "../ElementsDialog/ElementsDialog";

export default function ElementButton(props) {
  const { classes, propertyId, experienceId, gridView, tabStatus, disabled = false } = props;
  const dispatch = useDispatch();
  const simpleValues = useSelector(simpleValuesSelector);
  const { open: isRecordingDialogOpen } = simpleValues["voice-memo-recording"] || {};
  const { isOpen: isElementDialogOpen } = useSelector(elementsDialogSelector());
  const { elements } = useSelector(elementsSelector(propertyId, experienceId));
  const { elements: contentElements } = useSelector(contentElementsSelector(propertyId));
  const filteredElement = tabStatus === TAB_STATUSES.HOMEBASE ? contentElements : elements;
  const filteredElements = filteredElement.filter(
    (item) => item.type === ELEMENT_TYPE.LINK || item.type === ELEMENT_TYPE.VOICE_MEMO,
  );
  const location = useLocation();

  const isOrganizationsSection = location.pathname.startsWith("/organizations");

  if (gridView || (isOrganizationsSection && tabStatus === TAB_STATUSES.HOMEBASE)) {
    return <></>;
  }

  return (
    <>
      <AccessControl
        allowedPermissions={["elements_sticky:create", "elements_sticky:update"]}
        accessCheck={(_, extraAccessData) => extraAccessData.tabStatus === TAB_STATUSES.HOMEBASE}
        extraAccessData={{ tabStatus }}
      >
        <Tooltip
          classes={{
            arrow: classes.arrow,
            tooltip: classes.tooltip,
          }}
          title={filteredElements.length ? "Manage Elements" : "Create Element"}
          placement="left"
          arrow
          data-testid="element-button-container"
        >
          <Fab
            className={classes.fabButtonRed}
            size="small"
            onClick={() => {
              dispatch(setElementsDialog(true));
            }}
            data-testid={filteredElements.length ? "element-button-edit" : "element-button-add"}
            disabled={disabled}
            style={{
              cursor: disabled ? "not-allowed" : undefined,
              opacity: disabled ? 0 : 1,
            }}
          >
            {filteredElements.length ? <EditWhite htmlColor="#fff" /> : <PlusWhite />}
          </Fab>
        </Tooltip>
        <ElementsDialog open={isElementDialogOpen && !isRecordingDialogOpen} />
      </AccessControl>
      <AccessControl
        allowedPermissions={["elements:create", "elements:update"]}
        accessCheck={(_, extraAccessData) => extraAccessData.tabStatus === TAB_STATUSES.CUSTOMIZE}
        extraAccessData={{ tabStatus, gridView }}
      >
        <Tooltip
          classes={{
            arrow: classes.arrow,
            tooltip: classes.tooltip,
          }}
          title={filteredElements.length ? "Manage Elements" : "Create Element"}
          placement="left"
          arrow
          data-testid="element-button-container"
        >
          <Fab
            className={classes.fabButtonRed}
            size="small"
            onClick={() => {
              dispatch(setElementsDialog(true));
            }}
            data-testid={filteredElements.length ? "element-button-edit" : "element-button-add"}
            disabled={disabled}
            style={{
              cursor: disabled ? "not-allowed" : undefined,
              opacity: disabled ? 0 : 1,
            }}
          >
            {filteredElements.length ? <EditWhite htmlColor="#fff" /> : <PlusWhite />}
          </Fab>
        </Tooltip>
        <ElementsDialog open={isElementDialogOpen && !isRecordingDialogOpen} />
      </AccessControl>
    </>
  );
}
